import React, { useEffect, useState } from 'react'

import { Button, Container, Dialog, Grid, IconButton, Paper, Typography } from '@mui/material'
import { PropsInterfaceDetalheJSON, StatusForm } from '../../../DevComponents/DataTableCrudJSON'

import ClsValidacao from '../../../Utils/ClsValidacao'

import CloseIcon from '@mui/icons-material/Close'
import CheckIcon from '@mui/icons-material/Check'
import InputText from '../../../DevComponents/InputText'
import Condicional from '../../../Layout/Condicional'
import { DrgConteudoPermitidoInterface } from '../../../ImportBackend/Interfaces/DrgInterfaces'

export default function DRGCorrespondenciaConteudoPermitidoJSON<T> ( {
  onConfirmarExclusao,
  onConfirmarEdicaoInclusao,
  onCancelar,
  open,
  statusForm,
  registro,
  titulo
}: PropsInterfaceDetalheJSON<T> ) {

  const TituloForm = {
    [StatusForm.Incluindo]: 'Inclusão conteúdo permitido',
    [StatusForm.Excluindo]: 'Exclusão de conteúdo permitido',
    [StatusForm.Exibindo]: 'Cadastro de Conteúdo permitido',
    [StatusForm.Editando]: 'Alteração de dados de conteúdos permitidos',
    [StatusForm.Inicial]: 'Conteúdo permitido'
  }

  const resetDados: DrgConteudoPermitidoInterface = {
    chave: '',
    descricaoConteudo: ''
  }

  const [dados, setDados] = useState<DrgConteudoPermitidoInterface>( { ...resetDados } )

  useEffect( () => {
    setDados( { ...registro as DrgConteudoPermitidoInterface } )
  }, [registro] )

  const [erros, setErros] = useState( {} )

  const validarDados = (): boolean => {

    let retorno: boolean = true
    let erros: { [key: string]: string } = {}

    let clsValidacao = new ClsValidacao()

    retorno = clsValidacao.naoVazio( 'chave', dados, erros, retorno )
    retorno = clsValidacao.naoVazio( 'descricaoConteudo', dados, erros, retorno )

    setErros( erros )

    return retorno

  }

  const btConfirmar = () => {

    if ( validarDados() ) {
      onConfirmarEdicaoInclusao( dados as any )
    }

  }

  return (
    <Dialog open={open} onClose={onCancelar}>

      <Container maxWidth="md" sx={{ my: 3 }}>

        <Paper variant="outlined" sx={{ padding: 2 }}>
          <Grid container sx={{ display: 'flex', alignItems: 'stretch' }}>

            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
              <Typography component="h5" variant="h5" align="left">
                {titulo}
                <Typography variant="body2" gutterBottom>
                  {TituloForm[statusForm]}
                </Typography>
              </Typography>

              <IconButton onClick={() => onCancelar()}>
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>

          <Grid item xs={12}>

            <InputText
              dados={dados}
              field='descricaoConteudo'
              label='Descrição do Conteúdo'
              maxLength={30}
              setState={setDados}
              disabled={![StatusForm.Editando, StatusForm.Incluindo].includes( statusForm )}
              erros={erros}
            />

          </Grid>

          <Grid item xs={12}>

            <InputText
              dados={dados}
              field='chave'
              label='Valor do DRG'
              maxLength={255}
              setState={setDados}
              disabled={![StatusForm.Editando, StatusForm.Incluindo].includes( statusForm )}
              erros={erros}
            />

          </Grid>
          {/*
          <Grid item xs={12}>
          
          <InputText
          dados={dados}
          field='conteudoDRG'
          label='(Para) Conteúdo DRG'
          maxLength={50}
          setState={setDados}
          disabled={![StatusForm.Editando, StatusForm.Incluindo].includes( statusForm )}
          erros={erros}
          />
          
          </Grid>
          */}

          <Grid item xs={12} sx={{ mt: 3 }}>

            <Condicional condicao={![StatusForm.Editando, StatusForm.Incluindo].includes( statusForm )}>
              <Button variant='contained' startIcon={<CheckIcon />} sx={{ my: 1, py: 1, mr: 2 }} onClick={() => onConfirmarExclusao()}>Confirmar</Button>
            </Condicional>

            <Condicional condicao={statusForm !== StatusForm.Excluindo}>
              <Button variant='contained' startIcon={<CheckIcon />} sx={{ my: 1, py: 1, mr: 2 }} onClick={() => btConfirmar()}>Confirmar</Button>
            </Condicional>

            <Button variant='contained' startIcon={<CloseIcon />} sx={{ py: 1 }} onClick={() => onCancelar()}>Cancelar</Button>

          </Grid>

        </Paper>
      </Container>



      {/*
      <DialogTitle>{titulo}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {TituloForm[statusForm]}
        </DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          id="name"
          label="Email Address"
          type="email"
          fullWidth
          variant="standard"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancelar}>Cancel</Button>
        <Button onClick={handleClose}>Subscribe</Button>
      </DialogActions>
  */}
    </Dialog>
  )

}